import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import * as Chart from 'chart.js';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';


import { AuthService } from '../services/auth.service';
import { ProfissionalService } from '../services/profissional.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-ranking-condutores',
  templateUrl: './ranking-condutores.component.html',
  styleUrls: ['./ranking-condutores.component.css'],
	animations: [loadingFade, modal, alert]
})
export class RankingCondutoresComponent implements OnInit {

	public loading = false;
  public condutores = {condutor_nome: [], condutor_pontos: [] ,condutor_multa: []};
  
  public chart;
  public showFilter = true;
  public clientes = [];

    // filtro
  public filtro = [];
  public dadosFiltrados = [];

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  public formFiltro: FormGroup;

  public veiculos = [];
  public unidades = [];
  public profissionais = [];
  public aviso = "";

  constructor(private authSvc:AuthService,
              private fb: FormBuilder,
              private clienteSvc: ClienteService,
              private unidadeSvc: UnidadeService,
              private veiculoSvc: VeiculoService,
              private profissionalSvc:ProfissionalService,) { }

  ngOnInit() {
    //this.condutoresChart();
    this.criaFiltro();
  }

 

  filtra() {

    let filtroSelect = true;
    if(this.formFiltro.value.cliente_id___cliente == null && this.formFiltro.value.unidade_id___unidade == null 
      && this.formFiltro.value.profissional_id___profissional == null && this.formFiltro.value.multa_data___data_i == null){
      filtroSelect = false;
    }

    if(!filtroSelect){
      this.aviso = "Favor Preencher pelo menos um filtro";
    }else{
      this.filtro = this.formFiltro.value;
      this.condutoresChart();
      this.aviso = "";
    }


  }

  
  expandPanel() {
    this.showFilter = this.showFilter == true ? false : true;
  }


  criaFiltro() {
    this.pegaClientes();
    this.pegaProfissionaisClienteUnidadeFull();
    this.pegaUnidades();

    this.formFiltro = this.fb.group({
      cliente_id___cliente: null,
      unidade_id___unidade: null,
      profissional_id___profissional: null,
      multa_data___data_i: null,
      multa_data___data_f: null
    });

    let campos_data = ['multa_data___data_i', 'multa_data___data_f'];
    moment.locale('pt-Br');
    for (let campo of campos_data) {
      Datepicker('#' + campo, {
        customMonths: moment.months(),
        customDays: moment.weekdaysShort(),
        overlayPlaceholder: 'Preencha o ano',
        overlayButton: 'Enviar',
        formatter: (element, date) => {
          let formatted = moment(date).format('DD/MM/YYYY');
          this.formFiltro.controls[campo].setValue(formatted);
        }
      });
    }

  }

  onChangeCliente(evento) {
    this.formFiltro.controls.unidade_id___unidade.setValue(null);
    //this.formFiltro.controls.veiculo_id___veiculo.setValue(null);
    this.formFiltro.controls.profissional_id___profissional.setValue(null);

    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaProfissionaisClienteUnidadeFull(){
    this.loading = true;
    
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;

      this.loading = false;
		}).catch((err) => {
			console.log(err);
		});
  } 


  pegaProfissionaisClienteUnidade(e){
    this.loading = true;
    
    this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
			this.profissionais = data;

      this.loading = false;
		}).catch((err) => {
			console.log(err);
		});
  } 

  onChangeVeiculoUnidade(e){

    this.aviso = "";
    this.loading = true;
		this.veiculos = []
		this.veiculoSvc.getByVeiculoClienteUnidade(e.unidade_id,e.cliente_id).then((data: any[]) => {

        let dados = [];
        for(let veiculo of data){
          dados.push({
            veiculo_id: veiculo.veiculo_id,
            placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
            unidade_id: e.unidade_id,
            cliente_id: e.cliente_id
          });
        }

        this.veiculos = dados;

        this.pegaProfissionaisClienteUnidade(e);

        this.loading = false;
      }).catch((err) => {
        console.log(err);
      });
	}

  pegaClientes() {
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.clientes = data;
    });
  }


  onClickLimparCampos(){
  
    location.reload();

    this.chart = null;
    this.condutores.condutor_multa = [];
    this.condutores.condutor_pontos = [];
    this.condutores.condutor_nome = [];

    this.pegaClientes();
    this.pegaProfissionaisClienteUnidadeFull();
    this.pegaUnidades();

    this.formFiltro = this.fb.group({
      cliente_id___cliente: null,
      unidade_id___unidade: null,
      profissional_id___profissional: null,
      multa_data___data_i: null,
      multa_data___data_f: null
    });    


	}

    pegaUnidades(){
      this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.unidades = data;
      }).catch((err) => {
        console.log(err);
      });
    }


  condutoresChart(){


    this.chart = null;
    this.condutores.condutor_multa = [];
    this.condutores.condutor_pontos = [];
    this.condutores.condutor_nome = [];
    
    
    this.loading = true;
    this.profissionalSvc.getCondutoresByUsuarioGrafico(this.authSvc.getUsuarioId(), this.filtro).then((data: any) =>{
      for(let condutor of data){
        this.condutores.condutor_nome.push(condutor.profissional_nome);
        this.condutores.condutor_pontos.push(condutor.profissional_pontuacao_cnh);
        this.condutores.condutor_multa.push(condutor.multas.length);
      }


      this.chart = new Chart('canvas', {
        type: 'horizontalBar',
        data: {
          labels: this.condutores.condutor_nome,
          datasets: [
            { 
              label: "Multas",
              data: this.condutores.condutor_multa,
              backgroundColor: "#55b7f4"
            },
            {
              label: "Pontuação CNH",
              data: this.condutores.condutor_pontos,
              backgroundColor: "red"
            }
          ]
        },
        options: {
          legend: {
            display: true,
            labels: {
              boxWidth: 30
            }
          }
        }
      });



      this.loading = false;
    }).catch((err) =>{
      console.log(err);
    });
		
  }
}
